import { render, staticRenderFns } from "./BotForm.vue?vue&type=template&id=ae18dfc0"
import script from "./BotForm.vue?vue&type=script&lang=ts"
export * from "./BotForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports